export const buildQueryString = (params: object) => {
  return Object.entries(params)
    .filter(([, value]) => Boolean(value) || value === 0)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
};
